import React, { Component } from "react";
import { connect } from "react-redux";
import { Table } from '@mawesi-sas/mws_react_component_table';
import FontAwesome from "react-fontawesome";
import Input from '@mawesi-sas/mws_react_component_input';

import Box from "../Layout/components/Box";
import ButtonStrip from "../Layout/components/ButtonStrip";
import BoxButton from "../Layout/components/BoxButton";
import ModalEditStatus from "./components/ModalEditStatus";

import {
  getDataFromServer,
  reiniciarEstado,
  showHideModalEditStatus
} from "./actions";
import history from "../../utils/history";

const WAIT_INTERVAL = 500;
const ENTER_KEY = 13;

class Solicitudes extends Component {
  constructor(props) {
    super(props);
    this.state = { filter: false };
  }

  componentWillMount() {
    this.props.reiniciarEstado();
    this.props.getDataFromServer();
  }

  handleOnChange = value => {
    clearTimeout(this.timer);
    this.setState({ value });
    this.timer = setTimeout(this.triggerChange, WAIT_INTERVAL);
  };

  handleOnKeyDown = key => {
    if (key.keyCode === ENTER_KEY) {
      clearTimeout(this.timer);
      this.triggerChange();
    }
  };

  triggerChange = () => {
    this.props.getDataFromServer();
  };

  render() {
    const { user, solicitudes } = this.props;
    if (!this.props.elementos) return null;
    const isSuOrAdmin = user
      .get("roles")
      .some(x => x.get("name") === "su" || x.get("name") === "admin");

    const buttons = [];
    buttons.push(
      <BoxButton
        key={`action[0][1]`}
        name="filter"
        onClick={e => this.setState({ filter: !this.state.filter })}
        title="Filtrar"
      />
    );
    if (isSuOrAdmin) {
      const isAnySelected =
        !!solicitudes && !solicitudes.valueSeq().some(x => x.get("selected"));
      buttons.push(
        <BoxButton
          key={`action[0][2]`}
          name="exchange"
          onClick={e => this.props.showHideModalEditStatus(true)}
          title="Modificar estado"
          disabled={isAnySelected}
        />
      );
    }

    return (
      <div
        style={{
          height: "100%",
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between"
        }}
      >
        <div className="row" style={{ height: "100%" }}>
          <div className="col-md-12" style={{ height: "100%" }}>
            <Box title="Mis solicitudes" stretch>
              <ButtonStrip actions={buttons} />
              {this.state.filter && (
                <div className="buttonstrip">
                  <Input
                    type="text"
                    reducer="solicitudes"
                    path="filter"
                    afterChange={this.handleOnChange}
                    onKeyDown={this.handleOnKeyDown}
                    placeholder="Filtrar..."
                  />
                </div>
              )}

              <div
                className="box-content"
                style={{
                  flex: 1,
                  height: 0
                }}
              >
                <Table
                  reducer="solicitudes"
                  table="solicitudes"
                  selectionMode="multiple"
                  take={100}
                  columns={[
                    {
                      ID: 0,
                      CAPTION: "",
                      VALUE: "selected",
                      TYPE: "selection",
                      INPUT: "checkbox",
                      WIDTH: 24,
                      FIXED: true
                    },
                    {
                      ID: 1,
                      CAPTION: "Solicitud",
                      WIDTH: 90,
                      TYPE: "custom",
                      FIXED: true,
                      RENDER_ROW: reg => {
                        return (
                          <span
                            style={{
                              color: "#4f9fcf",
                              cursor: "pointer"
                            }}
                            onClick={e =>
                              history.push(
                                `${window.FOLDER}/solicitudes/${reg.get("id")}`
                              )
                            }
                          >
                            {reg.getIn("id".split("."))}
                          </span>
                        );
                      }
                    },
                    {
                      ID: 11,
                      CAPTION: "Estado",
                      WIDTH: 80,
                      TYPE: "custom",
                      FIXED: true,
                      RENDER_ROW: reg => {
                        const estado = reg.get("estado").toUpperCase();
                        let color = "default";
                        switch (estado) {
                          case "CREADA":
                            color = "info";
                            break;
                          case "APROBADA":
                            color = "warning";
                            break;
                          case "CANCELADA":
                            color = "danger";
                            break;
                          case "COMPLETADA":
                            color = "success";
                            break;
                          case "FACTURADA":
                            color = "primary";
                            break;
                        }
                        return (
                          <span
                            style={{
                              fontSize: "1em",
                              display: "block",
                              margin: "2px 0"
                            }}
                            className={`label label-${color}`}
                          >
                            {reg.get("estado").toUpperCase()}
                          </span>
                        );
                      }
                    },
                    {
                      ID: 2,
                      CAPTION: "Fecha y hora",
                      VALUE: "fecha_hora",
                      TYPE: "date"
                    },
                    {
                      ID: 3,
                      CAPTION: "Evento/Actividad",
                      VALUE: "evento_actividad",
                      TYPE: "text"
                    },
                    {
                      ID: 4,
                      CAPTION: "Cafetería",
                      VALUE: "nombre_cafeteria",
                      TYPE: "text"
                    },
                    {
                      ID: 5,
                      CAPTION: "Lugar",
                      VALUE: "lugar",
                      TYPE: "text"
                    },
                    {
                      ID: 6,
                      CAPTION: "Motivo",
                      VALUE: "motivo",
                      TYPE: "text"
                    },
                    {
                      ID: 7,
                      CAPTION: "Total",
                      VALUE: "valor_total",
                      TYPE: "number",
                      FORMAT: "$0,0.00"
                    },
                    {
                      ID: 8,
                      CAPTION: "Extemporanea",
                      WIDTH: 90,
                      TYPE: "custom",
                      RENDER_ROW: reg => (
                        <div
                          style={{
                            textAlign: "center"
                          }}
                        >
                          <FontAwesome
                            name={`${
                              Number(reg.get("extemporanea")) ? "check-" : ""
                            }square`}
                          />
                        </div>
                      )
                    },
                    {
                      ID: 9,
                      CAPTION: "Solicitante",
                      VALUE: "solicitante.name",
                      TYPE: "text"
                    },
                    {
                      ID: 10,
                      CAPTION: "Recursos",
                      WIDTH: 400,
                      TYPE: "custom",
                      RENDER_ROW: reg => {
                        return reg.get("distribuciones").map(x => {
                          return (
                            <span
                              key={`span[0][${x.get("id")}]`}
                              title={x.getIn("cenco.nombre".split("."))}
                              style={{
                                fontSize: "1em"
                              }}
                              className={`label label-light-grey`}
                            >
                              {x.getIn("cenco.codigo".split("."))}
                              &nbsp;|&nbsp;
                              {x.get("porcentaje")}%
                            </span>
                          );
                        });
                      }
                    }
                  ]}
                  onCambiarPagina={pg => this.props.getDataFromServer(pg)}
                />
              </div>
            </Box>
          </div>
        </div>
        <ModalEditStatus />
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    elementos: state.layout.get("elementos"),
    user: state.signin.get("user"),
    solicitudes: state.solicitudes.getIn("solicitudes.data".split("."))
  };
}

const mapDispatchToProps = {
  reiniciarEstado,
  getDataFromServer,
  showHideModalEditStatus
};

export default connect(mapStateToProps, mapDispatchToProps)(Solicitudes);
